import React from 'react';
import Icon from '../../../components/AppIcon';

const SocialLoginButton = ({ provider, icon, onClick, disabled }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="w-full flex items-center justify-center gap-3 px-4 py-3 md:py-3.5 border border-border rounded-lg hover:bg-muted transition-base disabled:opacity-50 disabled:cursor-not-allowed touch-target"
      aria-label={`Sign in with ${provider}`}
    >
      <Icon name={icon} size={20} />
      <span className="font-medium text-sm md:text-base">Continue with {provider}</span>
    </button>
  );
};

export default SocialLoginButton;